export enum SettingPromotionMenuTypeEnum {
  ALL = 'ALL',
  CODE = 'CODE',
  CHALLENGE = 'CHALLENGE',
  SALE = 'SALE',
}
